<template>
  <div>
    <validation-observer ref="twFactorCheckRules">
      <b-form>
        <h5 class="section-label mb-2 mt-2">
          {{ $t('Enable 2FA') }}
        </h5>
        <b-row class="match-height mt-1 mb-2">
          <b-col
            md="6"
            class="d-flex flex-row"
          >
            <SwitchButton
              v-model="twoFactorCheckList.enable2FA"
              :label="$t('Enable 2FA')"
              name="enable-2fa"
              :readonly="isReadonly"
            />
          </b-col>
        </b-row>
        <div v-if="twoFactorCheckList.enable2FA">
          <b-row
            class="d-flex align-items-center"
          >
            <b-col md="6">
              <SelectField
                id="two-factor-option"
                v-model="twoFactorCheckList.twoFactorOption"
                :reduce="option => option"
                :label="$t('Two Factor Authentication')"
                :placeholder="$t('Select')"
                :options="twoFactorOptions"
                rules="required"
                :error-name="$t('Two Factor Authentication')"
                item="label"
              />
            </b-col>
          </b-row>
        </div>
      </b-form>
      <FullScreenSpinner :show="showSpinner" />
    </validation-observer>
    <div class="mt-2">
      <Button
        v-if="getUserPermission('UPDATE_SECURITY_CONFIG')"
        :label="$t('Update')"
        :loading="isLoading"
        :disabled="isDisabled"
        size="lg"
        @click="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { mapActions } from 'vuex'
import SelectField from '../../../../forms/SelectField.vue'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '@/helpers/permissions'
import SwitchButton from '../../../../components/switch/Switch.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    ValidationObserver,
    SwitchButton,
    SelectField,
    Button,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],

  data() {
    return {
      isLoading: false,
      isDisabled: false,
      twoFactorCheckList: {
        enable2FA: false,
        twoFactorOption: '',
      },
      twoFactorOptions: ['EMAIL', 'SMS'],
    }
  },
  mounted() {
    this.fetchTwoFactors()
  },
  methods: {
    ...mapActions({
      getFraudChecks: 'eChannels/getFraudChecksList',
      updateFruadChecks: 'eChannels/updateFraudCheckAction',
    }),
    async fetchTwoFactors() {
      try {
        this.showSpinner = true
        const response = await this.getFraudChecks({
          permission: eChannelsPermission.VIEW_SECURITY_CONFIG,
        })
        const { status, data } = response
        if (status === 200) {
          this.twoFactorCheckList = data
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async twoFactorAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          ...this.twoFactorCheckList,
        }
        const response = await this.updateFruadChecks({
          formData, permission: eChannelsPermission.UPDATE_SECURITY_CONFIG,
        })
        const { status } = await response
        if (status === 200) {
          this.hideModal('modal-lg')
          this.alertSuccess({ text: this.$t('Your request to Update Two Factor Authentication was successful') })
        }
      } catch (error) {
        this.hideModal('modal-lg')
        error.response.data.errors.forEach(responseError => {
          const reasonText = this.$t('Your request to Update Two Factor Authentication failed. Reason')
          this.alertError({ text: `${reasonText}: ${responseError.errorMessage}` })
        })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async handleSubmit() {
      this.$refs.twFactorCheckRules.validate().then(async success => {
        if (success) {
          this.confirm(this.twoFactorAction, { text: this.$t('Are you sure you want to Update Two Factor Authentication?') })
        }
      })
    },
  },
}
</script>
